import SectionHeading from "@/components/feature/SectionHeading";
import { testimonials } from "@/mocks/site";

export default function TestimonialSection() {
  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <SectionHeading
          eyebrow="用户口碑"
          title="读者怎么说"
          desc="来自长期关注事件复盘读者的真实反馈，也是我们继续保持克制的理由。"
        />

        <div className="mt-9 grid grid-cols-1 gap-5 sm:grid-cols-2">
          {testimonials.map((item) => (
            <figure
              key={item.name}
              className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-6"
            >
              <div className="flex items-center gap-1 text-accent-600">
                {Array.from({ length: 5 }).map((_, index) => (
                  <i
                    key={index}
                    className={`${index < item.rating ? "ri-star-fill" : "ri-star-line"} text-sm`}
                  ></i>
                ))}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-7 text-foreground-700">
                {item.content}
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-500 font-heading text-sm font-bold text-background-50">
                  {item.initial}
                </span>
                <span>
                  <span className="block text-sm font-medium text-foreground-900">{item.name}</span>
                  <span className="block text-xs text-foreground-500">{item.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}